import _Vue from 'vue';
import loadingMaskState from '@/types/loadingMaskState';

var _loadingMaskState: loadingMaskState = {
    bVisible : false,
    message : ""
}

export default function loadingMaskPlugIn(Vue: typeof _Vue): void {
    Vue.prototype.$loadingMask = _loadingMaskState;
}